"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var classNames = require('classnames');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TextInput = require('../textInput');

var inputConfiguration = {
  validateInitialValue: false,
  // This will prevent the initial "onChange" to be called
  syncDelay: 0,
  // This make sure validation are done synchroniously
  blurOnEnterKey: true,
  blurOnEscKey: true,
  focus: true,
  //TODO - remove from comoponent and change to prop
  initialSelectionStart: 0 //TODO - remove from comoponent and change to prop, this is business logic, you can expose via props

};

var EditableListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(EditableListItem, _React$Component);

  var _super = _createSuper(EditableListItem);

  function EditableListItem(props) {
    var _this;

    _classCallCheck(this, EditableListItem);

    _this = _super.call(this, props);
    _this.state = {
      newValueCandidate: props.initialValue,
      value: props.initialValue,
      isCandidateValid: true
    };

    _this.onBlur = function (e, isCanceled) {
      var _this$props = _this.props,
          onCancel = _this$props.onCancel,
          onConfirm = _this$props.onConfirm;
      var _this$state = _this.state,
          isCandidateValid = _this$state.isCandidateValid,
          newValueCandidate = _this$state.newValueCandidate,
          value = _this$state.value;

      if (isCanceled || !isCandidateValid) {
        //restore the previous valid value
        _this.setState({
          newValueCandidate: value,
          isCandidateValid: true
        }, function () {
          return onCancel();
        });
      } else {
        //accpet the new value
        _this.setState({
          value: newValueCandidate
        }, function () {
          return onConfirm(newValueCandidate);
        });
      }
    };

    _this.onInputChange = function (newValueCandidate) {
      _this.setState({
        newValueCandidate: newValueCandidate,
        isCandidateValid: _this.props.validator(newValueCandidate)
      });
    };

    return _this;
  }

  _createClass(EditableListItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          getClassName = _this$props2.getClassName,
          dataHook = _this$props2.dataHook,
          depth = _this$props2.depth,
          getInvalidMessage = _this$props2.getInvalidMessage,
          size = _this$props2.size,
          focus = _this$props2.focus,
          initialSelectionStart = _this$props2.initialSelectionStart,
          initialSelectionEnd = _this$props2.initialSelectionEnd;
      var _this$state2 = this.state,
          newValueCandidate = _this$state2.newValueCandidate,
          isCandidateValid = _this$state2.isCandidateValid;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: getClassName(classNames('tree-list-rename-item', {
          size: size
        }))
      }, /*#__PURE__*/React.createElement("div", {
        className: "depth-margin",
        style: {
          '--baseui-tree-list-rename-item-depth': depth
        }
      }), /*#__PURE__*/React.createElement(TextInput, _extends({
        className: "tree-list-rename-input",
        dataHook: "text-input"
      }, inputConfiguration, {
        focus: focus,
        initialSelectionStart: initialSelectionStart,
        initialSelectionEnd: initialSelectionEnd,
        isValid: this.state.isCandidateValid,
        invalidMessage: isCandidateValid ? '' : getInvalidMessage(newValueCandidate),
        onBlur: this.onBlur.bind(this),
        onChange: this.onInputChange.bind(this),
        value: newValueCandidate
      })));
    }
  }]);

  return EditableListItem;
}(React.Component);

EditableListItem.displayName = displayNames.EDITABLE_LIST_ITEM;
EditableListItem.propTypes = {
  /** Hook for testing purposes  */
  dataHook: PropTypes.string,
  depth: PropTypes.number,

  /** invoked when value is invalid to generate */
  getInvalidMessage: PropTypes.func.isRequired,
  initialValue: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),

  /** when validator returns true, value is valid */
  validator: PropTypes.func.isRequired,

  /* TextInput props - focus */
  focus: PropTypes.bool,

  /* TextInput props - initialSelectionStart */
  initialSelectionStart: PropTypes.number,

  /* TextInput props - initialSelectionEnd */
  initialSelectionEnd: PropTypes.number
};
EditableListItem.defaultProps = {
  depth: 0,
  size: 'medium'
};
module.exports = compose(EditableListItem);